// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChXMmtpsHaQ549E3a4HdeMOyV3dMNIOkY",
  authDomain: "setupracingapp.firebaseapp.com",
  projectId: "setupracingapp",
  storageBucket: "setupracingapp.firebasestorage.app",
  messagingSenderId: "135740653403",
  appId: "1:135740653403:web:050135bb46608d2c4da47e"
};

// Inizializza i servizi
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});
const storage = getStorage(app);

// Esporta tutto insieme
export { auth, db, storage };